import { usePubSub } from "@videosdk.live/react-sdk";
import React, { useEffect, useState } from "react";
import useIsMobile from "../utils/useIsMobile";
import { fontMap, logType, useJourney } from "../utils/common";
import { useAppContext } from "../AppContextDef";
import { Trans, useTranslation } from "react-i18next";
import useIsTab from "../utils/useIsTab";
import usePubsubFunction from "../utils/usePubsubFunction";

const Thankyou = ({ isPubSubPage = false }) => {
  const { publish: publishCurrentPage } = usePubSub(`CURRENT_PAGE`);
  const { logJourney } = useJourney();

  let isMobile = useIsMobile();
  let isTab = useIsTab();
  let isMobileOrTab = isMobile || isTab;
  const {
    applicationNo,
    setIsMeetingEnded,
    selectedLang,
    allPubsubData,
    terminationFlag,
  } = useAppContext();

  const { i18n, t } = useTranslation();
  const pubsubPublishMethod = usePubsubFunction();
  const [showTerminationMessage, setShowTerminationMessage] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    changeLanguage(selectedLang?.lang);
  }, [selectedLang]);

  useEffect(() => {
    // Check if termination message should be shown
    const terminationFlagFromStorage = sessionStorage.getItem("showTerminationMessage");
    const shouldShowFromStorage = terminationFlagFromStorage === "true";

    const finalFlag = terminationFlag || shouldShowFromStorage;
    setShowTerminationMessage(finalFlag);
    
    // Clear the flag after reading from storage
    if (shouldShowFromStorage) {
      sessionStorage.removeItem("showTerminationMessage");
    }
  }, [terminationFlag]);

  useEffect(() => {
    if (!isPubSubPage) {
      logJourney({
        type: logType.NAVIGATION,
        message: showTerminationMessage ? "Navigated to Termination Page" : "Navigated to Thank You Page",
      });
    }
  }, [showTerminationMessage]);

  useEffect(() => {
    setIsMeetingEnded(true);
    pubsubPublishMethod(publishCurrentPage, "page", { persist: true }, { message: "Thankyou" });
  }, []);

  let appNo = applicationNo ? applicationNo : allPubsubData?.applicationNo;

  const fontFamilyCSS = fontMap[selectedLang?.lang] || "Lato";

  return (
    <div
      // ref={screenShotRef}
      className="py-3 px-3 lg:py-10 lg:px-8 xl:px-14 w-full max-h-screen lg:h-full"
    >
      <div
        style={{
          backgroundImage:
            !isMobileOrTab &&
            "linear-gradient(360deg, rgba(107, 107, 184, 0) 81.6%, rgba(107, 107, 184, 0.1) 100%)",
        }}
        className="flex flex-1 flex-col h-full justify-center items-center  lg:border lg:border-gray-275 lg:rounded-xl lg:py-10"
      >
        <div className="w-full mt-0">
          {showTerminationMessage ? (
            <>
              <p
                style={{ fontFamily: fontFamilyCSS }}
                className="text-lg lg:text-2xl text-black text-center font-extrabold mb-0"
              >
                {t("Thank you for your response. Our representative will contact you soon.")}
              </p>
            </>
          ) : (
            <>
              <p
                style={{ fontFamily: fontFamilyCSS }}
                className="text-lg lg:text-2xl text-black text-center font-extrabold mb-0"
              >
                <Trans i18nKey="videoVerificationMessage" values={{ appNo }}>
                  Thank you for completing the Video Verification for
                  <br className="hidden lg:block" /> Application Number{" "}
                  {{ appNo }}
                </Trans>
              </p>

              <div className="mt-3">
                <p
                  style={{ fontFamily: fontFamilyCSS }}
                  className="text-center text-sm lg:text-lg text-gray-150"
                >
                  <Trans i18nKey="customerCareMessage">
                    Please refer to your policy documents after issuance to check
                    the terms and conditions <br className="hidden md:block" />{" "}
                    during the 30-day free look period and contact us if you have
                    any concerns.
                    <br className="hidden md:block" /> You may reach out to us on
                    18002660 or visit our website/mobile app
                  </Trans>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Thankyou;
